import { json as jsonLang } from "@codemirror/lang-json";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box, IconButton, Tooltip } from "@mui/material";
import { githubLight } from "@uiw/codemirror-theme-github";
import CodeMirror from "@uiw/react-codemirror";

import { JSON_PANEL_HEIGHT } from "@/components/FormEngine/components/JsonViewer/constants";

type JsonViewerProps = {
  value: string;
  onCopy: () => void;
};

export const JsonViewer = ({ value, onCopy }: JsonViewerProps) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 1,
      height: JSON_PANEL_HEIGHT,
    }}
  >
    <Box
      sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
    >
      <Tooltip title='Copier le JSON'>
        <IconButton onClick={onCopy} size='small' aria-label='Copier le JSON'>
          <ContentCopyIcon fontSize='small' />
        </IconButton>
      </Tooltip>
    </Box>

    <Box
      sx={{
        flex: 1,
        overflow: "auto",
        borderRadius: 1,
        border: (t) => `1px solid ${t.palette.divider}`,
      }}
    >
      <CodeMirror
        value={value}
        theme={githubLight}
        extensions={[jsonLang()]}
        readOnly
        height='100%'
        basicSetup={{ lineNumbers: true, foldGutter: true }}
      />
    </Box>
  </Box>
);
